export {
  ACCOUNT_DELETION_CONTACT_EMAIL,
  type AccountDeletionRequest,
  buildAccountDeletionMailtoUrl,
} from "#account-deletion-request";
